<template>
    <div class="vue-megamenu-category">
        <picture v-if="category.image && isActive">
            <img :src="category.image.replace(/(.jpg|.png)/, '_ew40_ew40.webp')" width="40" height="40" loading="lazy"/>
        </picture>
        <div class="vue-megamenu-category__container">
            <a :href="addStoreToUrl(category.url, storeTitle)" class="vue-megamenu-category__name vue-megamenu-arrow-mobile">{{ category.name }}</a>
            <div class="vue-megamenu-category__subcategory-container">
                <a
                    class="vue-megamenu-category__subcategory"
                    :href="addStoreToUrl(category.url, storeTitle)"
                    v-for="(category, index) in categoriesSliced"
                    v-bind:index="index"
                    v-bind:key="category.id"
                >{{ category.name }}</a>
            </div>
            <div v-if="showOthers"><a :href="addStoreToUrl(category.url, storeTitle)" class="vue-megamenu-category__others vue-megamenu-arrow"><span>{{ $t("megamenu.otherCategories") }}</span></a></div><!-- Ten <div> je, aby fungoval last-of-type na <a> -->
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { ICategory } from './../type'
import addBranchSlugToUrl from '@/helper/addBranchSlugToUrl'

export default defineComponent({
    props: ['category', 'isActive'],
    name: 'Category',
    data () {
        return {
            categories: [] as ICategory[],
        }
    },
    computed: {
        categoriesSliced () {
            return this.categories.slice(0, 4)
        },
        showOthers () {
            return this.categories.length > 4
        },
        storeTitle () {
            return window.config.getBranchSlug()
        },
    },
    methods: {
        addStoreToUrl: addBranchSlugToUrl,
        isWideScreen () {
            return !window.matchMedia('(max-width: 980px)').matches
        },
    },
    created () {
        this.categories = this.$props.category.category as ICategory[]
    },
    // updated () {
    //     this.$nextTick(function () {
    //         this.$emit('category-updated');
    //     });
    // },
    // beforeDestroy() {
    //     if (this.xhr) {
    //         this.xhr.abort();
    //     }
    // },
})
</script>
